/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are these returns guaranteed?`)
};

const es_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estos retornos están garantizados?`)
};

const de_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind diese Renditen garantiert?`)
};

const nl_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijn deze rendement gegarandeerd?`)
};

const fr_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces rendements sont-ils garantis ?`)
};

const it_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questi rendimenti sono garantiti?`)
};

const pt_br2_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses retornos são garantidos?`)
};

const pt_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estes retornos são garantidos?`)
};

const ja_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これらのリターンは保証されていますか？`)
};

const zh_sip_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些收益是有保证的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_hub_faq3_q", locale)
	if (locale === "en") return en_sip_hub_faq3_q(inputs)
	if (locale === "es") return es_sip_hub_faq3_q(inputs)
	if (locale === "de") return de_sip_hub_faq3_q(inputs)
	if (locale === "nl") return nl_sip_hub_faq3_q(inputs)
	if (locale === "fr") return fr_sip_hub_faq3_q(inputs)
	if (locale === "it") return it_sip_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_hub_faq3_q(inputs)
	if (locale === "pt") return pt_sip_hub_faq3_q(inputs)
	if (locale === "ja") return ja_sip_hub_faq3_q(inputs)
	return zh_sip_hub_faq3_q(inputs)
};